
<section class="container-fluid sts-section">

  <app-sts-section-header *ngIf="!changeUserId" key="sts-signup-step-2-header" [errors]="errors">
    Pick username
    <app-sts-section-header-side>
      <div class="text-right"><a
        routerLink="/account/help" app-sts-cms-txt key="sts-need-help">Need help?</a>
      </div>
    </app-sts-section-header-side>
  </app-sts-section-header>

  <app-sts-section-header *ngIf="changeUserId" key="sts-change-login-username" [errors]="errors">
    enter a Unique User ID
    <app-sts-section-header-side>
      <div class="text-right"><a
        routerLink="/account/help" app-sts-cms-txt key="sts-need-help">Need help?</a>
      </div>
    </app-sts-section-header-side>
  </app-sts-section-header>

  <app-sts-section-body key="sts-registration-step-2-body-section">
    <!-- content is served by CMS -->
  </app-sts-section-body>


  <form #form="ngForm" (ngSubmit)="onSubmit()"
        [formGroup]="signUpForm"
        class="sts-form" autocomplete="off">

    <div class="row sts-form-row">
      <div class="col-24">

        <!-- -->
        <div class="sts-object">

          <div class="sts-label-row">

            <label app-sts-cms-txt key="sts-pick-login-email" for="sts-pick-login-email">
              Personal email address:
            </label>
          </div>
          <div class="sts-input-row">
            <input type="text"
                   name="sts_pick_email"
                   formControlName="emailInput"
                   maxlength="100"
                   [ngClass]="{'has-errors' : !signUpForm.controls['emailInput'].valid }"
                   class="sts-textbox" >
            <div class="text-danger" *ngIf="signUpForm.controls['emailInput'].invalid">
              <div app-sts-cms-txt key="sts-email-is-unique-required" *ngIf="signUpForm.controls['emailInput'].errors['emailRequired']">An email is required</div>
              <div app-sts-cms-txt key="sts-email-is-valid-required" *ngIf="signUpForm.controls['emailInput'].errors['validateEmail']">A valid email is required</div>
            </div>
          </div>


        </div>
        <!-- -->



      </div>
    </div>

    <div class="row">
      <div class="col-24">

        <!-- -->
        <div class="sts-object">
          <button app-sts-cms-txt key="sts-cancel-button"
                  class="sts-btn other-sts-btn"
                  type="button"
                  (click)="gotoHome()">
            Cancel
          </button>
          <app-sts-button [submit]="submitter"
                          key="sts-next-button">
            Next
          </app-sts-button>
        </div>
        <!-- -->

      </div>
    </div>

  </form>


</section>


